import { axiosInstance } from "../utils/axios";

// Login API
export const loginApi = async ({ profileId, password }) => {
  return await axiosInstance.post("/meeting-hub/auth/login", {
    profileId,
    password,
  });
};

// Verify OTP API (step 2 of MFA login)
export const verifyOtpApi = async ({ mfaToken, otp }) => {
  return await axiosInstance.post("/meeting-hub/auth/verify-otp", {
    mfaToken,
    otp,
  });
};

// Resend OTP API
export const resendOtpApi = async ({ mfaToken }) => {
  return await axiosInstance.post("/meeting-hub/auth/resend-otp", {
    mfaToken,
  });
};

// RefreshTokens API — participant session renewal. Refresh is handled
// automatically by the axios response interceptor on 401; this is kept for any
// explicit callers. Body is { token }, matching the backend
// /meeting-hub/auth/refresh route (the admin /auth/refresh rejects MEETING_HUB).
export const refreshTokensApi = async (refreshToken) => {
  return await axiosInstance.post("/meeting-hub/auth/refresh", {
    token: refreshToken,
  });
};

// Forgot Password API (step 1) — sends a 6-digit reset code to the account
// email. Always resolves 200 (enumeration-safe); returns { token, message }.
export const forgotPasswordApi = async ({ email }) => {
  return await axiosInstance.post("/meeting-hub/auth/forgot-password", {
    email,
  });
};

// Verify Reset OTP API (step 2) — exchanges the forgot-password token + the
// emailed code for a short-lived resetToken. 400 on invalid/expired code.
export const verifyResetOtpApi = async ({ token, otp }) => {
  return await axiosInstance.post("/meeting-hub/auth/verify-reset-otp", {
    token,
    otp,
  });
};

// Reset Password API (step 3) — sets the new password using the resetToken.
// 400 on rule violation / mismatch / expired session.
export const resetPasswordApi = async ({
  resetToken,
  newPassword,
  confirmPassword,
}) => {
  return await axiosInstance.post("/meeting-hub/auth/reset-password", {
    resetToken,
    newPassword,
    confirmPassword,
  });
};

// Update Password API
export const updatePasswordApi = async ({ oldPassword, newPassword }) => {
  return await axiosInstance.put("/meeting-hub/auth/update-password", {
    oldPassword,
    newPassword,
  });
};
